import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import context from '@/context'
import {
  BsrsGrid,
  Column,
  commandColumnProps,
  createLookupFilterCell,
  DateCell,
  DateFilterCell, LookupCell
} from '@/components/BsrsGrid'
import { format } from '@/utils/StringUtilities'
import { useLocalization } from '@/hooks/localization'

const OutputReportGroups = React.memo(() => {
  const { localize } = useLocalization()

  return <Main>
    <MainTop>
      <MainTopTitle>
        <Resx name='Reporting.OutputReportGroupsTitle' />
      </MainTopTitle>
    </MainTop>
    <MainBody>
      <BsrsGrid persistenceId={'output-report-groups'}
        dataSource={request => context.api.outputReportGroupService.getTableData(localize('Common.CBI'), false, request)}
        defaultSort={[ { field: 'creationTime', dir: 'desc' } ]}>
        <Column field='name' title={localize('Common.Name')} editable={false} />
        <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
        <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' cell={DateCell}
          filterCell={DateFilterCell} editable={false} />
        <Column field='definition' title={localize('Common.Definition')} cell={LookupCell}
          filterCell={createLookupFilterCell(context.cache.getOutReportGroupDefinitionsCached)} />
        <Column {...commandColumnProps({ detailUrl: x => format('/output-report-groups/{0}/output-reports', x.id) })}
          title=' ' width={150} />
      </BsrsGrid>
    </MainBody>
  </Main>
})

export default OutputReportGroups



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReports/outputReportGroups.js